/**
 * Application configuration settings with support for custom overrides via Stencil blocks.
 */
export const appConfig = Object.assign(
    {
        useDefaultLayout: true,
    },
    {
        // Override app-level configuration (e.g., useDefaultLayout, feature flags) below
        // <<Stencil::Block(appConfig)>>
        useDefaultLayout: false,
        // <</Stencil::Block>>
    },
);
